import React from 'react';
import { useMutation } from 'react-query';
import { dateTimeHelpers, downloadAndOpenFile } from '@crx-dev/hss-react-infrastructure';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Form, getFieldProps, Inputs, Label, Modal, ModalFormFooter } from '@crx-dev/hss-react-components';

interface ExportFormProps {
    registerId: string;
    dateFrom: string;
    dateTo: string;
    onCancel: () => void;
}

interface ExportFormFields {
    dateFrom: string;
    dateTo: string;
}

function ExportForm({ registerId, dateFrom, dateTo, onCancel }: ExportFormProps) {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const mutation = useMutation<unknown, unknown, any>(
        item =>
            downloadAndOpenFile(
                'GET',
                `/api/v1/controldrugregister/${registerId}/report?dateFrom=${item.dateFrom}&dateTo=${item.dateTo}&timeZone=${timeZone}`,
                'application/pdf'
            ),
        {
            onSuccess: () => {
                onCancel();
            }
        }
    );

    const formik = useFormik<ExportFormFields>({
        initialValues: {
            dateFrom: dateFrom || dateTimeHelpers.getStartOfMonth(),
            dateTo: dateTo || dateTimeHelpers.getCurrentDateAsISOString()
        },
        validationSchema: yup.object().shape({
            dateFrom: yup
                .date()
                .required('Required')
                .max(yup.ref('dateTo'), 'Invalid date range'),
            dateTo: yup
                .date()
                .required('Required')
                .min(yup.ref('dateFrom'), 'Invalid date range')
        }),
        onSubmit: values => {
            mutation.mutate(values);
        }
    });

    return (
        <Modal onCancel={onCancel} open={true} title="Export Register">
            <Form onSubmit={formik.handleSubmit}>
                <br />
                <Label label="From Date" htmlFor="dateFrom" />
                <Inputs.DatePicker
                    {...getFieldProps(formik, 'dateFrom')}
                    maxDate={formik.values.dateTo}
                    clearable={false}
                />
                <Label label="To Date" htmlFor="dateTo" />
                <Inputs.DatePicker
                    {...getFieldProps(formik, 'dateTo')}
                    minDate={formik.values.dateFrom}
                    clearable={false}
                />

                <ModalFormFooter
                    isSubmitting={mutation.isLoading}
                    onCancel={onCancel}
                    submitButtonLabel="EXPORT"
                    submitError={mutation.isError}
                />
            </Form>
        </Modal>
    );
}

export default ExportForm;
